import { ModuleWithProviders, NgModule } from '@angular/core';
import { ZuperConfigService } from '@zuper/services/config/config.service';
import { ZUPER_APP_CONFIG } from '@zuper/services/config/config.constants';

@NgModule()
export class ZuperConfigModule
{
    /**
     * Constructor
     */
    constructor(private _zuperConfigService: ZuperConfigService)
    {
    }

    /**
     * forRoot method for setting user configuration
     *
     * @param config
     */
    static forRoot(config: any): ModuleWithProviders<ZuperConfigModule>
    {
        return {
            ngModule : ZuperConfigModule,
            providers: [
                {
                    provide : ZUPER_APP_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
